export enum EquipmentPaymentType {
  EquipmentUpgrade = 'EquipmentUpgrade',
  PayNowWithSubscription = 'PayNowWithSubscription',
  PayNowWithoutSubscription = 'PayNowWithoutSubscription',
}

export enum EquipmentPaymentTypeName {
  PayNowWithSubscription = 'Betal nå med tilbehørsbinding',
  PayNowWithoutSubscription = 'Betal nå uten abonnement',
}
